import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { appClient, /*notificationClient*/ } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";

export const markReadNotification = (id: string | undefined): Promise<{}> => {
  return appClient.httpClient.put(`${PATHS.notificationService.baseURL}/mark-as-read/${id}`);
};

export const useMarkReadNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.NOTIFICATIONS] });
      notification.success({
        message: "Marked as read.",
        description: "Notification has been successfully marked read.",
        duration: 2,
      });
    },

    mutationFn: markReadNotification,
  });
};
